<script>
export default {
  name: 'TherapistTableMobile',
  props: ['data'],
}
</script>

<template>
  <div class="invoice-rd">
    <table>
      <tbody>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Name' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">{{data.full_name}}</p>
          </td>
        </tr>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Phone Number' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">{{data.phone || '-'}}</p>
          </td>
        </tr>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Email' | translate}}</td>
          <td class="invoice-rd__content--email">
            <p class="invoice-rd__content text-14 fw-500 color-default">{{data.email || '-'}}</p>
          </td>
        </tr>
        <tr>
          <td class="invoice-rd__content text-14 fw-700">{{'Address' | translate}}</td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">{{data.address || '-'}}</p>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
</template>

<style lang="less" scoped>
@import "./../../less/redesign/vars";
.text-left {
  text-align: left;
}
.invoice-rd {
  border: 1px solid @grey-hover;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  & table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  & tr td:first-child {
    background-color: @grey-hover;
  }
  & td, th {
    padding: 20px 24px;
  }
  & tbody tr, tfoot tr:not(:last-child) {
    border-bottom: 1px solid @grey-hover;
  }
  &__content {
    text-align: center;
  }
  &__col-group {
    width: 200px;
  }

  @media screen and (max-width: 670px) {
    .invoice-rd__col-group {
      width: auto;
    }

    td,
    th {
      padding: 14px 10px;
    }

    .invoice-rd__content--email {
      display: flex;

      p {
        flex-grow: 1;
        width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  @media screen and (max-width: 420px) {
    td,
    th {
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/TherapistTableMobile.vue